import { render, staticRenderFns } from "./ReviewListPaginatedForSimulation.vue?vue&type=template&id=1bc6ef0c&scoped=true&"
import script from "./ReviewListPaginatedForSimulation.vue?vue&type=script&lang=js&"
export * from "./ReviewListPaginatedForSimulation.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListPaginatedForSimulation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReviewListPaginatedForSimulation.vue?vue&type=style&index=1&id=1bc6ef0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc6ef0c",
  null
  
)

component.options.__file = "ReviewListPaginatedForSimulation.vue"
export default component.exports